import { FC, useRef, MouseEventHandler } from "react";
import close from "./close.svg";
import * as Type from './type';

import style from "./style.module.scss";

export const Modal: FC<Type.IModal> = ({ children, isCloseBy, onClose = () => {} }: Type.IModal) => {

  const modalBGDOM = useRef();

  /** 如果點的是背景的話... */
  const handleClickBG: MouseEventHandler<HTMLDivElement> = ({ target }) => {
    if(!isCloseBy) {
      if(target === modalBGDOM.current) onClose(false);
    }
  };

  return (
    <div data-testid="Modal" className={style.ModalBG} onClick={handleClickBG} ref={modalBGDOM}>
      <div className={style.Modal}>
        <div className={style.close} onClick={onClose.bind(null, false)}>
          <img src={close} alt="close" />
        </div>
        {children}
      </div>
    </div>
  );
};